import {
  FilterTabEnum,
  JobItem,
  JobTypeEnum,
  JobUIStatusEnum,
} from 'domains/workspaceDomain';
import { JobShippingSummaryItem } from 'domains/workspaceDetailDomain';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'app/hooks';
import { JobParticipantEnum } from 'domains/workspaceDomain';

const { CUSTOMER, PROXY, PRODUCER, OPERATOR } = JobParticipantEnum;
const { SHIPPING_BILLING } = FilterTabEnum;
const {
  NEED_ARTWORK,
  PURCHASE_ORDER,
  PROOFING,
  PENDING_PO,
  IN_PRODUCTION,
  SHIPPING,
  INVOICING,
} = JobUIStatusEnum;
const InternalDistributionBlock = ({
  jobData,
  item,
}: {
  jobData: JobItem;
  item?: JobShippingSummaryItem;
}) => {
  const { participants, jobType, activeTab } = jobData;
  const isInternalJob = jobType === JobTypeEnum.INTERNAL;
  const isCustomer =
    participants.includes(CUSTOMER) || participants.includes(PROXY);
  const isProducerInternal = participants.includes(PRODUCER) && isInternalJob;
  const isOperator = participants.includes(OPERATOR);
  const { t } = useTranslation();
  const uiFilterCache = useAppSelector(
    (state) => state.workspace.uiStatusFilter
  );
  const showInternalDistribution = () => {
    if (activeTab === SHIPPING_BILLING) {
      switch (uiFilterCache) {
        case NEED_ARTWORK:
          return isCustomer || isProducerInternal || isOperator;
        case PURCHASE_ORDER:
          return isProducerInternal || isOperator;
        case PROOFING:
        case PENDING_PO:
        case IN_PRODUCTION:
        case SHIPPING:
        case INVOICING:
          return isCustomer || isOperator;
        default:
          return false;
      }
    }
  };
  if (!showInternalDistribution() || !item?.shippingInfo.internalDistribution) {
    return <></>;
  }
  const {
    shippingInfo: { internalDistribution },
  } = item;
  const { quantity, distribution } = internalDistribution;
  return (
    <div className="shipping-item-address-distribution mt-20">
      <label>
        {t('workspace.detail.shippingBilling.internalDistribution')}:
      </label>
      {internalDistribution && (
        <p>
          <span>{quantity && <span>QTY: {quantity} | </span>}</span>
          <span>{distribution}</span>
        </p>
      )}
    </div>
  );
};

export default InternalDistributionBlock;
